const isString = (subject: any) =>
  ({}.toString.call(subject) === "[object String]");

export default isString;
